/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

/**
 * Where the player stands with your agency — not their contract
 */
export type CreatePlayerDtoRepresentation = typeof CreatePlayerDtoRepresentation[keyof typeof CreatePlayerDtoRepresentation];


export const CreatePlayerDtoRepresentation = {
  signed: 'signed',
  prospect: 'prospect',
  other_agency: 'other_agency',
  unrepresented: 'unrepresented',
} as const;
